/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Capacity_HintInputs */

const en_admin_resource_form_capacity_hint = /** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many people can use this resource together?`)
};

const de_admin_resource_form_capacity_hint = /** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Personen in diesen Raum passen`)
};

const es_admin_resource_form_capacity_hint = /** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuántas personas caben en esta sala`)
};

const fr_admin_resource_form_capacity_hint = /** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de personnes peuvent utiliser cette ressource ensemble ?`)
};

/** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */
const it_admin_resource_form_capacity_hint = en_admin_resource_form_capacity_hint;

/** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_capacity_hint = en_admin_resource_form_capacity_hint;

/** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */
const pl_admin_resource_form_capacity_hint = en_admin_resource_form_capacity_hint;

/** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */
const hu_admin_resource_form_capacity_hint = en_admin_resource_form_capacity_hint;

/** @type {(inputs: Admin_Resource_Form_Capacity_HintInputs) => LocalizedString} */
const ro_admin_resource_form_capacity_hint = en_admin_resource_form_capacity_hint;

/**
* | output |
* | --- |
* | "How many people can use this resource together?" |
*
* @param {Admin_Resource_Form_Capacity_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_capacity_hint = /** @type {((inputs?: Admin_Resource_Form_Capacity_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Capacity_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_capacity_hint(inputs)
	if (locale === "de") return de_admin_resource_form_capacity_hint(inputs)
	if (locale === "es") return es_admin_resource_form_capacity_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_capacity_hint(inputs)
	if (locale === "it") return it_admin_resource_form_capacity_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_capacity_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_capacity_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_capacity_hint(inputs)
	return ro_admin_resource_form_capacity_hint(inputs)
});
export { admin_resource_form_capacity_hint as "admin.resource_form.capacity_hint" }